import React from "react";

/**
 * Official Gigma brand mark — squircle with blue + green halves,
 * a flowing white river through the center, and a yellow accent.
 */
export function GigmaMark({ size = 36, className = "" }) {
  return (
    <img
      src="/gigma-mark.png"
      alt="Gigma"
      width={size}
      height={size}
      className={className}
      style={{ display: "block", width: size, height: size }}
      draggable={false}
    />
  );
}

export function GigmaWordmark({ size = 30, className = "", showSub = false }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="gigma-wordmark">
      <GigmaMark size={size} />
      <div className="flex flex-col leading-none">
        <span className="font-heading font-semibold text-[1.35rem] tracking-tight text-slate-900">
          Gigma
        </span>
        {showSub && (
          <span className="text-[10px] font-medium tracking-[0.18em] text-slate-400 uppercase mt-0.5">
            by NRFSTR
          </span>
        )}
      </div>
    </div>
  );
}
